(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-grid-item"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ng-collection-gallery')) {
  customElements.define('ng-collection-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-ng-gallery-track]');
      const data = this.querySelector('[data-ng-gallery-images]');
      if (!this.track || !data) return;
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.previous = this.querySelector('[data-ng-gallery-prev]');
      this.next = this.querySelector('[data-ng-gallery-next]');
      this.dotList = this.querySelector('[data-ng-gallery-dots]');
      this.status = this.querySelector('[data-ng-gallery-status]');
      if (!this.built) {
        let images;
        try { images = JSON.parse(data.textContent); } catch { return; }
        if (!Array.isArray(images) || images.length < 2) return;
        const firstLink = this.track.querySelector('a');
        const firstImage = firstLink.querySelector('img');
        const slides = document.createDocumentFragment();
        const dots = document.createDocumentFragment();
        images.forEach((source, index) => {
          if (index > 0) {
            const link = firstLink.cloneNode(false);
            const img = document.createElement('img');
            const src = typeof source === 'string' ? source : source.src;
            if (!src) return;
            const url = new URL(src, window.location.href);
            const widths = [320, 480, 640, 960, 1280, 1600, 1920];
            img.srcset = widths.map(width => {
              const sized = new URL(url);
              sized.searchParams.set('width', width);
              return `${sized.href} ${width}w`;
            }).join(', ');
            url.searchParams.set('width', 1920);
            img.src = url.href;
            img.sizes = firstImage.sizes;
            img.alt = source.alt || firstImage.alt;
            img.width = source.width || firstImage.width;
            img.height = source.height || firstImage.height;
            img.loading = 'lazy';
            img.decoding = 'async';
            img.draggable = false;
            img.className = 'ng-card-gallery__image';
            link.append(img);
            slides.append(link);
          }
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ng-card-gallery__dot';
          dot.dataset.ngGalleryIndex = index;
          dot.setAttribute('aria-label', `${this.getAttribute('aria-label')} · ${index + 1} / ${images.length}`);
          dots.append(dot);
        });
        this.track.append(slides);
        this.dotList.append(dots);
        this.built = true;
        this.index = 0;
      }
      this.slides = Array.from(this.track.children);
      this.dots = Array.from(this.dotList.children);
      this.count = this.slides.length;
      this.track.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (!this.track.clientWidth) return;
          this.index = Math.max(0, Math.min(this.count - 1, Math.round(this.track.scrollLeft / this.track.clientWidth)));
          this.update();
        });
      }, { ...options, passive: true });
      this.addEventListener('click', event => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        if (target.closest('a') && performance.now() < (this.ignoreClickUntil || 0)) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        const dot = target.closest('[data-ng-gallery-index]');
        if (dot) this.goTo(Number(dot.dataset.ngGalleryIndex));
        else if (target.closest('[data-ng-gallery-prev]')) this.goTo(this.index - 1);
        else if (target.closest('[data-ng-gallery-next]')) this.goTo(this.index + 1);
      }, { ...options, capture: true });
      this.track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.goTo(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        this.slides[this.index].focus({ preventScroll: true });
      }, options);
      this.track.addEventListener('pointerdown', event => {
        this.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, moved: false };
      }, { ...options, passive: true });
      this.track.addEventListener('pointermove', event => {
        if (!this.pointer || this.pointer.id !== event.pointerId) return;
        if (Math.abs(event.clientX - this.pointer.x) > 10 || Math.abs(event.clientY - this.pointer.y) > 10) {
          this.pointer.moved = true;
        }
      }, { ...options, passive: true });
      const finishPointer = event => {
        if (this.pointer?.moved || event.type === 'pointercancel') this.ignoreClickUntil = performance.now() + 500;
        this.pointer = null;
      };
      this.track.addEventListener('pointerup', finishPointer, { ...options, passive: true });
      this.track.addEventListener('pointercancel', finishPointer, { ...options, passive: true });
      this.track.addEventListener('dragstart', event => event.preventDefault(), options);
      this.resizeObserver?.disconnect();
      this.resizeObserver = new ResizeObserver(() => {
        if (this.track.clientWidth) this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'instant' });
      });
      this.resizeObserver.observe(this.track);
      this.classList.add('is-ready');
      this.update();
    }

    goTo(index) {
      this.index = Math.max(0, Math.min(this.count - 1, index));
      this.track.scrollTo({
        left: this.index * this.track.clientWidth,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
      this.update();
    }

    update() {
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index === this.count - 1;
      this.slides.forEach((slide, index) => { slide.tabIndex = index === this.index ? 0 : -1; });
      this.dots.forEach((dot, index) => {
        if (index === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      this.status.textContent = `${this.index + 1} / ${this.count}`;
      const dot = this.dots[this.index];
      const left = dot.offsetLeft;
      const right = left + dot.offsetWidth;
      if (left < this.dotList.scrollLeft) this.dotList.scrollLeft = left;
      else if (right > this.dotList.scrollLeft + this.dotList.clientWidth) this.dotList.scrollLeft = right - this.dotList.clientWidth;
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.pointer = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
